import { createSelector } from 'reselect';
import { State } from 'flow/types/State';

export const selectUserConferences = (state: State) =>
    state.pbx.get('conferences');

export const selectFirstConferenceKey = createSelector(
    selectUserConferences,
    (conferences) => conferences?.first()?.get('key') ?? null,
);
